<alaris-dialog [closeAction]="close.bind(this)"
			   [confirmAction]="confirm.bind(this)"
			   [loading$]="clientsService.loading$"
			   size="md">
	<h6 slot="header">{{ 'clients.removingDialog' | translate }}</h6>
	<div slot="content">
		<h3><strong>{{ data.client.login }}</strong></h3>
	</div>
</alaris-dialog>